import React from 'react';

import styles from './styles.module.scss';
import {BlockBig, RadarBig, UserBig, CenterBig} from '../../../assets/icons/antiNuke';

export const AntiNukeFeatureBig = () => {
  return (
    <div className={styles.wrapper}>
      <BlockBig />
      <div className={styles.radar}>
        <RadarBig />
      </div>
      <div className={styles.user1}>
        <UserBig />
      </div>
      <div className={styles.user2}>
        <UserBig />
      </div>
      <div className={styles.user3}>
        <UserBig />
      </div>

      <div className={styles.center}>
        <CenterBig />
      </div>
    </div>
  );
};
